import { useMemo } from 'react'
import Column from '@app/components/layout/Column'
import { CreationGuide } from '@app/pages/dashboard/initiative/create/blocks/CreationGuide'
import { useTranslations } from '@i18n/useLanguage'
import { eventCreationSteps, type EventCreationStep } from '../shared/workflow'
import type { CollectedEventData } from '../shared/eventTypes'
import { Image } from '@app/components/core/image/Image'
import PointerIllustration from '@app/assets/images/illustrations/pointer.png'
import { EventPageMobile } from '@app/pages/events/EventPage.mobile'
import { PhoneFrame } from '@app/components/core/phoneFrame/PhoneFrame'
import { MediaQueryOverrideContext } from '@app/util/useMediaQuery'
import { buildPreviewEvent } from '../shared/buildPreviewEvent'

const CURRENT_STEP: EventCreationStep = eventCreationSteps.preview

type Props = {
  data: CollectedEventData
}

export const PreviewStep = ({ data }: Props) => {
  const t = useTranslations().app.dashboard.event.creation
  const previewEvent = useMemo(() => buildPreviewEvent(data), [data])

  const stepTitles = { [CURRENT_STEP]: t.steps.preview.title }
  const stepDescriptions = { [CURRENT_STEP]: t.steps.preview.description }

  return (
    <CreationGuide
      steps={[CURRENT_STEP]}
      currentStep={CURRENT_STEP}
      stepTitles={stepTitles}
      stepDescriptions={stepDescriptions}
      illustration={
        <Image
          src={PointerIllustration}
          alt="Pointer Illustration"
          style={{ maxWidth: '15rem' }}
        />
      }
    >
      <Column gap="2rem" alignItems="center">
        <MediaQueryOverrideContext.Provider value={true}>
          <PhoneFrame height={650} style={{ alignSelf: 'center' }}>
            <EventPageMobile event={previewEvent} />
          </PhoneFrame>
        </MediaQueryOverrideContext.Provider>
      </Column>
    </CreationGuide>
  )
}
